import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './modalBody.scss';

export default function ModalBody({ children, className }) {
	return (
		<div className={classnames('modal-body', className)}>
			{children}
		</div>
	);
}

ModalBody.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string
};
